import React, { createRef, forwardRef, useContext, useEffect, useRef, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, HashRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { PRIMARY_COLOR } from "./constants";
import SnackbarWrapper from './components/common/snackbar';
import { createBrowserHistory, createHashHistory } from "history";
import mainRoutes from "./routes/index";
import { ROLES, ERROR_CODES, LOCAL_STORAGE_KEYS } from './constants';
import router from './routes';
import database from "./modules/database/database";
import { AuthContext } from './components/contextAPI/ContextAPI';
import PICON from "./icons/PICON.svg"
import PrivateRoute from './components/PrivateRoutes';
import { CircularProgress, CssBaseline } from '@mui/material';
import $ from 'jquery';
import Drawer from './components/Drawer';
import Header from "./components/common/drawer/drawer";
import CommomHeader from './components/common/commonHeader/commonHeader';
// import { Spinner } from '@mui/material';
import "./App.css";
import CustomConfirmModal from './components/modals/CustomConfirmModal';
import NotificationsDrawer from './components/notificationsDrawer/notificationsDrawer';
import ComponentWrapper from './components/common/drawer/drawer';
// import FadeRoute from './routes/FadeRoutes';
import OpaqueLoading from './components/opaqueLoading/opaqueLoading';
import ThemeCustomization from './components/themes';
import ScrollTop from './components/ScrollTop';
import ConsentDetails from './views/consentDetails/ConsentDetails';
import LiveAudit from './views/liveAudit/LiveAudit'



const history = createBrowserHistory();
const isMobile = window.innerWidth < 900;


window.Platform.database = database;
window.$ = $;

function App({ setShowNotifications, showNotifications }) {
  const [userLoading, setUserLoading] = useState(false)
  const { auth, setAuth } = useContext(AuthContext)

  const [roleAccess, setRoleAccess] = useState([])

  const [loggedIn, setLoggedIn] = useState(false)
  const [user, setUser] = useState(null)
  const [roleAccessLoading, setRoleAccessLoading] = useState(false)
  const [moduleAccess, setModuleAccess] = useState([])
  const [loading, setLoading] = useState(false);

  const notificationsRef = useRef();
  const notificationDrawerRef = useRef(null);
  const [notificationCount, setNotificationCount] = useState(0)
  let contextState = { ...auth };

  const fetchNotifications = async () => {
    try {
      let results = await window.Platform.database.fetchNotifications(auth.user.role);
      setNotificationCount(results.length)
    } catch (error) {

    }
  };
 


  useEffect(() => {
    let storedUser;
    storedUser = JSON.parse(
      window.localStorage.getItem(LOCAL_STORAGE_KEYS.STORED_USER_DATA)
    );


    if (storedUser) {
      setUser(storedUser);
      contextState.loggedIn = true
      contextState.token = storedUser.sessionToken
      contextState.user = storedUser
      contextState.email = storedUser.email
      contextState.onAuthUserChanged = onAuthUserChanged
      contextState.onUserChange = onUserChange
      contextState.history = history
      contextState.setShowNotifications = setShowNotifications
      contextState.showNotifications = showNotifications
      setAuth(contextState)
      // setAuth(storedUser)
      setLoggedIn(true);
    } else {

      logout();
    }

    getRolesAccess(storedUser)
  }, []);

  const renderLoading = () => {
    return (
      <div className="loadingCentered">
        <CircularProgress color="primary" />
      </div>
    );
  };



  const getRolesAccess = async (user) => {
    try {
      setRoleAccessLoading(true)
      ////console.log("uuuser",user.user)
      const permissions = await database.getRole({ roleId: user.user.roleId })

      let roleArray = permissions.data[0].roleModuleId.split(',')
      const moduleAccess1 = permissions.moduleData.results.filter(obj => roleArray.includes(obj.moduleId));
      let modules = moduleAccess1.map(obj => obj.moduleName)

      setModuleAccess(modules)



      contextState.permissions = moduleAccess1

    } catch (error) {
      
    }
    finally {
      setRoleAccessLoading(false)
    }
  }

  const logout = async () => {
    // window.localStorage.clear();
    window.localStorage.removeItem("storedUserData");
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("isDrawerOpen");

    contextState.loading = true
    setLoggedIn(false)
    setUser(null)
    var currentPath = history.location;
    // ////console.log(currentPath.pathname)
    if (currentPath.pathname !== "/login" && currentPath.pathname !== "/quotationapprovallink"
      && currentPath.pathname !== "/platformInvite") {
      let redirectPath = "/login";
      // ////console.log("redirectionpath", redirectPath);
      history.replace(redirectPath);

    }
  };

  const onAuthUserChanged = async () => {
    try {
      contextState.loading = true
      onUserChange();

    } catch (e) {
      ////console.error(e);
      window.Platform.database.signOut(user);
      return;
    }
    finally {
      contextState.loading = false
    }
  }






  const onUserChange = async (forced = false) => {
    try {
      setUserLoading(true)

      let userData = JSON.parse(
        window.localStorage.getItem(LOCAL_STORAGE_KEYS.STORED_USER_DATA)
      );
      if (userData && userData.user) {

        setUser(userData)

        contextState.loggedIn = true
        contextState.token = userData.user.sessionToken
        contextState.email = userData.user.email
        contextState.user = { "user": userData.user }
        contextState.onAuthUserChanged = onAuthUserChanged
        contextState.onUserChange = onUserChange
        contextState.history = history
        ////console.log("conntext",contextState)
        setAuth(contextState)
        setLoggedIn(true)

      }
      window.localStorage.setItem(
        LOCAL_STORAGE_KEYS.STORED_USER_DATA,
        JSON.stringify(userData)
      );
      var currentPath = history.location;
      // ////console.log("this will be the path",currentPath);
      if (currentPath.pathname === "/login") {
        let redirectPath = "/";
        history.replace(redirectPath);
      }
      else {
        throw "error"
      }
    } catch (error) {
      logout();
      if (error === ERROR_CODES.INVALID_ROLE_ACCESS) {
        window.NotificationUtils.showError("Something went wrong");
        // ////console.log(error.message)
      }
      return;
    }
    finally {
      setUserLoading(false)
    }
  }

  const renderNavBarHeader = (prop) => {
    if (prop.hideNavBar || isMobile) {
      return;
    }
    let location = history.location;


    return (


      <CommomHeader style={{ height: "10px" }} header={prop} location={location} />


    );
  };



  const renderContent = () => {
    let location = history.location;
    let path = (location && location.pathname) || "";
    if (path) {
      path = path.replace("/", "");
    }

    // Define userRow here
    let userRow = moduleAccess

    return (
      <>
        <div className="App">

          <Routes>
            <Route>
              <Route path='/:id' element={ConsentDetails}></Route>
              <Route path='/liveVisits' element={<LiveAudit />}></Route>

              {mainRoutes(loggedIn, user, history.location).map((prop, key) => {
                if (prop.redirect) {
                  return (
                    <Route
                      path={prop.path}
                      element={
                        <Navigate
                          to={
                            prop.pathTo + (loggedIn || !path ? "" : `?route=${path}`)
                          }
                          replace
                        />
                      }
                      key={key}
                    />
                  );
                }




                if (
                  prop?.access &&
                  moduleAccess?.length &&
                  moduleAccess.includes(prop?.access) === false &&
                  history.location.pathname.toLowerCase() === prop?.path
                ) {


                  return (
                    <Route
                      path="/"
                      element={<Navigate to="/" replace />}
                      key={key}
                    />
                  );
                  // }
                }

                if (prop.component) {
                  return (
                    <Route
                      exact
                      path={prop.path}
                      element={
                        <div
                          className="effectStyle"
                          style={{ opacity: 1, transition: "opacity 0.5s ease-in" }}
                        >
                          <PrivateRoute>
                            {location.pathname !== "/login" && <div style={{ display: "flex" }}>
                              <CssBaseline />
                              <Drawer open={true} onAuthUserChanged={onAuthUserChanged} moduleAccess={moduleAccess} />

                              <Header>
                                {renderNavBarHeader(prop)}
                                {/* <CommomHeader style={{height:"10px"}} /> */}
                                <prop.component
                                  user={user}
                                  loggedIn={loggedIn}
                                  onUserChange={onUserChange}
                                  onAuthUserChanged={onAuthUserChanged.bind(this)}
                                  history={history}
                                  showNotifications={showNotifications}
                                  setShowNotifications={setShowNotifications}
                                  notificationCount={notificationCount}
                                  fetchNotifications={fetchNotifications}
                                />
                              </Header>
                            </div>}

                            {location.pathname === "/login" && <div style={{ display: "flex" }}>

                              {/* <CommomHeader style={{height:"10px"}} /> */}
                              <prop.component
                                user={user}
                                loggedIn={loggedIn}
                                onUserChange={onUserChange}
                                onAuthUserChanged={onAuthUserChanged.bind(this)}
                                history={history}
                                showNotifications={showNotifications}
                                setShowNotifications={setShowNotifications}
                                notificationCount={notificationCount}
                                fetchNotifications={fetchNotifications}
                              />

                            </div>}
                          </PrivateRoute>
                        </div>
                      }
                      key={key}
                    />
                  );
                }

                return null;
              })}
            </Route>
          </Routes>

        </div>
      </>
    );
  };

  return (
    <div className="AppContainer">

      {!contextState.loading && !roleAccessLoading && !userLoading ? renderContent() :
        renderLoading()
      }

      {/* <Snackbar ref={this.notificationsRef} /> */}
    </div>
  );
}

function ThemeWrapper() {

  const theme = createTheme({
    MuiTextField: {
      defaultProps: {
        inputProps: { maxLength: 255 },
      },
    },
    typography: {
      fontFamily: '"Montserrat", sans-serif',
      htmlFontSize: 18,
    },
    palette: {
      secondary: {
        main: "#2D88D4",
        light: "rgb(106, 123, 131)",
        dark: "rgb(48, 62, 70)",
        contrastText: "#fff",
      },
      common: {
        black: "#000",
        white: "#fff",
      },
      error: {
        light: "#e57373",
        main: "#f44336",
        dark: "#d32f2f",
        contrastText: "#fff",
      },
      type: "light",
      action: {
        hoverOpacity: 0.08,
        hover: "rgba(0, 0, 0, 0.08)",
        selected: "rgba(0, 0, 0, 0.14)",
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabled: "rgba(0, 0, 0, 0.26)",
        active: "rgba(0, 0, 0, 0.54)",
      },
      primary: {
        main: PRIMARY_COLOR,
        light: "#E47F5D",
        dark: "#2D88D4",
        contrastText: "#fff",
      },
    },

  });

  const notificationRef = useRef();
  const confirmationModalRef = useRef();

  // useEffect(() => {
  // ////console.log(window.NotificationUtils)
  // window.NotificationUtils.showSuccess("login")
  // }, []);


  const initializeNotificationFunctions = () => {
    window.NotificationUtils = {

      showSuccess: (msg, params = {}) => {
        notificationRef.current.showSuccess(msg, params);
      },
      showError: (msg, params = {}) => {
        notificationRef.current.showError(msg, params);
      },
      showWarning: (msg, params = {}) => {
        notificationRef.current.showWarning(msg, params);
      },
      showInfo: (msg, params = {}) => {
        notificationRef.current.showInfo(msg, params);
      },
    };
  };
  const initializeModals = () => {
    window.requestPasswordReset = async (email = "") => {
      try {
        let em = email;
        if (!email) {
          em = this.state.user.email;
        }
        let res = await window.Platform.database.requestPasswordReset(em);
        //  ////console.log(res)

        window.NotificationUtils.showSuccess(
          "An email for password reset has been sent successfully"
        );
      } catch (error) {
        ////console.error(error);
        throw error;
      }
    };

    window.confirmationModal = (
      message,
      confirmCallback,
      cancelCallback,
      extras
    ) => {
      confirmationModalRef.current &&
        confirmationModalRef.current.show(
          message,
          confirmCallback,
          cancelCallback,
          extras
        );
    };

  }

  const initializeCommonUseFunctions = () => {


    window.trimEmail = (email) => {
      let trimmedEmail = email.trim();
      let result = trimmedEmail.toLowerCase();
      return result;
    };
    window.isValidPincode = (str) => {
      // Regex to check valid
      // Pincode of India
      if (str && str.length == 0)
        return true;
      else {

        let regex = new RegExp(/^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/);

        // if str
        // is empty return false
        if (str == null) {
          return "false";
        }

        // Return true if the str
        // matched the ReGex
        if (regex.test(str) == true) {
          return true;
        }
        else {
          return false;
        }
      }
    }
    window.isValidMobile = (mobile_number) => {
      // Regex to check valid
      // mobile_number 
      let regex = new RegExp(/^[6-9][0-9]{9}$/);

      // if mobile_number
      // is empty return false
      if (mobile_number == null) {
        return false;
      }

      // Return true if the mobile_number
      // matched the ReGex
      if (regex.test(mobile_number) == true) {
        return true;
      }
      else {
        return false;
      }
    }
    window.limitTextSize = (text, maxLength) => {

      if (text.length > maxLength) {
        return text.substring(0, maxLength) + "...";
      } else {
        return text;
      }
    }
  }


  initializeNotificationFunctions();
  initializeCommonUseFunctions();
  initializeModals();
  // verifyUserSession()

  const notificationDrawerRef = useRef(null);
  const [showNotifications, setShowNotifications] = useState(false);
  const [user, setUser] = useState([]);

  useEffect(() => {
    let storedUser;
    try {
      storedUser = JSON.parse(
        window.localStorage.getItem(LOCAL_STORAGE_KEYS.STORED_USER_DATA)
      );
      setUser(storedUser);
    } catch (error) {
      ////console.error(error);
    }
  }, []);

  return (

    <ThemeProvider theme={theme}>
      <HashRouter> {/* Add the Router component here */}
        {/* <ComponentWrapper setShowNotifications={setShowNotifications} /> */}
        <CustomConfirmModal ref={confirmationModalRef} />
        {user && (
          <NotificationsDrawer
            ref={notificationDrawerRef}
            setShowNotifications={setShowNotifications}
            showNotifications={showNotifications}
            history={history}
          />
        )}
        <SnackbarWrapper ref={notificationRef} />

        <ScrollTop>

          <App setShowNotifications={setShowNotifications} showNotifications={showNotifications} />
        </ScrollTop>

      </HashRouter>
    </ThemeProvider>
  );
}

export default ThemeWrapper;
